// En tu sección <script>
export const truncateText = (text, maxLength = 15) => {
  if (text === null || text === undefined || text === '') return '';
  const str = Array.isArray(text) ? text.join(', ') : String(text);
  if (str.length <= maxLength) return str;
  return str.substring(0, maxLength) + '...';
}